export default __webpack_public_path__ + "static/media/farm-MIVA-HNY.3a2a4a2e.svg";